const CLEAR_ASSISTER_LIST = 'CLEAR_ASSISTER_LIST';
const SET_ASSISTER_LIST = 'SET_ASSISTER_LIST';
const CHANGE_ASSISTER_LIST = 'CHANGE_ASSISTER_LIST';
const SET_CURRENT_ASSISTER = 'SET_CURRENT_ASSISTER';
const INIT_ALL_FILTERS = 'INIT_ALL_FILTERS';
const SET_FILTER_VALUE = 'SET_FILTER_VALUE';
const RESET_FILTER_VALUES = 'RESET_FILTER_VALUES';
const APPLY_FILTERS = 'APPLY_FILTERS';
const SET_ENTITY_SITE = 'SET_ENTITY_SITE';
const SET_COUNT = 'SET_COUNT';
const SET_FILTER_FORM_STATE = 'SET_FILTER_FORM_STATE';
const SET_EXPORT_BTN_STATE ='SET_EXPORT_BTN_STATE';
const SET_REASSIGN_BTN_STATE = 'SET_REASSIGN_BTN_STATE';
const SET_API_IN_PRG_FLAG = 'SET_API_IN_PRG_FLAG';

export const ASSISTER_LIST_TYPES = {
    CLEAR_ASSISTER_LIST,
    SET_ASSISTER_LIST,
    CHANGE_ASSISTER_LIST    
};

export const ASSISTER_FILTERS_TYPES = {
    INIT_ALL_FILTERS,
    SET_FILTER_VALUE,
    RESET_FILTER_VALUES,
    APPLY_FILTERS,
    SET_ENTITY_SITE
};

export const ASSISTER_PAGINATION_TYPES = {
    SET_COUNT,
    SET_CURRENT_ASSISTER,
    SET_API_IN_PRG_FLAG
};

export const ASSISTER_FILTER_VALIDATION_TYPES = { 
    SET_FILTER_FORM_STATE,
    SET_EXPORT_BTN_STATE,
    SET_REASSIGN_BTN_STATE
};